/* eslint-disable no-param-reassign */
import Vue, { VueConstructor } from 'vue';

import { Auth0AppState, RedirectCallback } from '@/services/auth0/VueAuth0Wrapper';
import { useAuth0 } from '@/services/auth0/useAuth0';

import router from '@/router/index';

export type Auth0PluginOptions = {
  onRedirectCallback: RedirectCallback;
  redirectUri: string;
  domain: string;
  clientId: string;
  audience?: string;
  [key: string]: string | RedirectCallback | undefined;
}

const vm = new Vue();

const Auth0Plugin = {
  install(Instance: VueConstructor, options: Auth0PluginOptions) {
    Instance.prototype.$auth = useAuth0(options);
  },
};

export default async function useAuth0PluginAsync() {
  return new Promise((resolve, reject) => {
    const authConfig = vm.$http.get<Auth0.Config>({
      url: `${window.location.origin}/auth_config.json`,
    });

    authConfig.then(({ data }: { data: Auth0.Config }) => {
      const configEmpty = Object.values(data).every((e) => e === '' || typeof e === 'undefined');

      if (configEmpty) {
        throw new Error(`Invalid Auth0 configuration object provided:\n\t\t${JSON.stringify(data)}`);
      }

      if (data.domain === '') {
        throw new Error(`Invalid Auth0 domain provided:\n\t\t${JSON.stringify(data.domain)}`);
      }

      Vue.use(Auth0Plugin, {
        ...data,
        onRedirectCallback: (appState: Auth0AppState) => {
          router.push(
            appState && appState.targetUrl
              ? appState.targetUrl
              : window.location.pathname,
          );
        },
      });

      resolve();
    }).catch(reject);
  });
}
